import { render } from "./TokenDetailTabs.vue?vue&type=template&id=0957eaa6&scoped=true"
import script from "./TokenDetailTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenDetailTabs.vue?vue&type=script&setup=true&lang=js"

import "./TokenDetailTabs.vue?vue&type=style&index=0&id=0957eaa6&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0957eaa6"],['__file',"resources/js/components/TokenDetailTabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0957eaa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0957eaa6', __exports__)) {
    api.reload('0957eaa6', __exports__)
  }
  
  module.hot.accept("./TokenDetailTabs.vue?vue&type=template&id=0957eaa6&scoped=true", () => {
    api.rerender('0957eaa6', render)
  })

}


export default __exports__